import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const names = ['María', 'Camila', 'Valentina', 'Luciana', 'Sofía', 'Carolina', 'Daniela', 'Florencia', 'Julieta', 'Martina', 'Gabriela', 'Andrea', 'Paula', 'Natalia', 'Laura', 'Alejandra', 'Fernanda', 'Catalina', 'Mariana', 'Rosa'];
const cities = ['Buenos Aires, Argentina', 'Córdoba, Argentina', 'Ciudad de México, México', 'Guadalajara, México', 'Bogotá, Colombia', 'Medellín, Colombia', 'Santiago, Chile', 'Lima, Perú', 'Montevideo, Uruguay', 'Quito, Ecuador', 'San José, Costa Rica', 'Asunción, Paraguay'];
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    const show = () => {
      setData({
        name: randomItem(names),
        city: randomItem(cities),
        minutes: Math.floor(Math.random() * 25) + 2
      });
      setVisible(true);
      window.setTimeout(() => setVisible(false), 4000);
    };
    const initialDelay = window.setTimeout(show, 6000);
    const interval = window.setInterval(show, 22000);
    return () => {
      window.clearTimeout(initialDelay);
      window.clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[17rem] sm:max-w-sm" data-id="element-164" data-mp="vb36hhl1ih07">
      <AnimatePresence data-id="element-165" data-mp="rbm08lxshftz">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white rounded-2xl shadow-xl border border-fil-beige p-4 flex items-start gap-3" role="status" data-id="element-166" data-mp="raatqecyltz6">
            <span className="w-9 h-9 rounded-full bg-fil-rose-light flex items-center justify-center shrink-0" data-id="element-167" data-mp="19zh9ptmdc7ha">
              <ShoppingBagIcon size={17} className="text-fil-terra" data-id="element-168" data-mp="1m3bqxq8008uf" />
            </span>
            <div className="flex-1 min-w-0" data-id="element-169" data-mp="1r2oc86j817uw">
              <p className="text-sm font-semibold text-fil-text leading-snug" data-id="element-170" data-mp="1r1myfuatm79h">
                {data.name} accedió a El Arte de la Filigrana
              </p>
              <p className="text-xs text-fil-taupe mt-0.5" data-id="element-171" data-mp="20shlh0vw5avz">{data.city}</p>
              <p className="text-[11px] text-fil-muted mt-1" data-id="element-172" data-mp="20ukabhlb4xz4">
                Hace {data.minutes} minutos
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-fil-muted hover:text-fil-text transition-colors duration-150 ease-out shrink-0" aria-label="Cerrar notificación" data-id="element-173" data-mp="29so04q3bsgwq">
              <XIcon size={15} data-id="element-174" data-mp="ffejmecd3v4z" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}